'use client';

import { useEffect } from 'react';
import { trackFunnelEvent } from '~/utils/funnelTracking';

const reportedTripIds = new Set<string>();

export const OverviewViewTracker = ({ tripId }: Readonly<{ tripId: string }>) => {
  useEffect(() => {
    if (!tripId || reportedTripIds.has(tripId)) return;
    reportedTripIds.add(tripId);
    trackFunnelEvent('trip_funnel_overview_view');
  }, [tripId]);

  return null;
};
